import Button from "../../../components/ui/Button";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";

const HeroSection = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(
      "Olá! Gostaria de solicitar uma análise financeira gratuita.",
    );
    window.open(`https://wa.me/553397070278?text=${message}`, "_blank");
  };

  const handleContactClick = () => {
    const element = document.getElementById("contato");
    if (element) {
      element?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section
      id="inicio"
      className="relative min-h-screen bg-gradient-to-br from-slate-50 to-white overflow-hidden"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-32 h-32 bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-secondary rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-16">
        <div className="grid lg:grid-cols-2 gap-12 items-center min-h-[80vh]">
          {/* Content */}
          <div className="space-y-8">
            {/* Trust Badge */}
            <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium">
              <Icon name="Shield" size={16} />
              <span>Certificado e Confiável</span>
            </div>

            {/* Main Headline */}
            <div className="space-y-4">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-tight">
                Soluções Financeiras que{" "}
                <span className="text-primary">Cabem no Seu Bolso</span> e no
                Seu Momento de Vida
              </h1>

              <p className="text-xl text-muted-foreground leading-relaxed max-w-2xl">
                Tratamento transparente e ético especialmente para aposentados,
                pensionistas e trabalhadores CLT. Sem burocracia, sem
                pegadinhas, apenas soluções reais para sua tranquilidade
                financeira.
              </p>
            </div>

            {/* Key Benefits */}
            <div className="grid sm:grid-cols-3 gap-4">
              <div className="flex items-center space-x-3 bg-white p-4 rounded-lg shadow-subtle">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name="Users" size={20} className="text-primary" />
                </div>
                <div>
                  <p className="font-semibold text-foreground">15.000+</p>
                  <p className="text-sm text-muted-foreground">
                    Clientes Atendidos
                  </p>
                </div>
              </div>

              <div className="flex items-center space-x-3 bg-white p-4 rounded-lg shadow-subtle">
                <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
                  <Icon name="Clock" size={20} className="text-success" />
                </div>
                <div>
                  <p className="font-semibold text-foreground">24h</p>
                  <p className="text-sm text-muted-foreground">
                    Resposta Garantida
                  </p>
                </div>
              </div>

              <div className="flex items-center space-x-3 bg-white p-4 rounded-lg shadow-subtle">
                <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
                  <Icon name="Award" size={20} className="text-accent" />
                </div>
                <div>
                  <p className="font-semibold text-foreground">100%</p>
                  <p className="text-sm text-muted-foreground">Transparente</p>
                </div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                variant="default"
                size="lg"
                onClick={handleWhatsAppClick}
                iconName="MessageCircle"
                iconPosition="left"
                className="text-lg px-8 py-4 shadow-cta hover:shadow-lg transition-all duration-300"
              >
                Solicite Análise Gratuita
              </Button>

              <Button
                variant="outline"
                size="lg"
                onClick={handleContactClick}
                iconName="Phone"
                iconPosition="left"
                className="text-lg px-8 py-4"
              >
                Fale Conosco
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="flex flex-wrap items-center gap-6 pt-4">
              <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Icon name="Shield" size={16} className="text-primary" />
                <span>CNPJ: 63.284.659/0001-37</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Icon name="MapPin" size={16} className="text-primary" />
                <span>Atendimento Nacional</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Icon name="Lock" size={16} className="text-primary" />
                <span>Dados Protegidos</span>
              </div>
            </div>
          </div>

          {/* Hero Image */}
          <div className="relative">
            <div className="relative z-10">
              <Image
                src="https://images.unsplash.com/photo-1709211077213-93591e643c43"
                alt="Casal de idosos brasileiros sorrindo em casa, demonstrando tranquilidade financeira e segurança"
                className="w-full h-auto rounded-2xl shadow-2xl"
              />
            </div>

            {/* Floating Cards */}
            <div className="absolute -top-4 -left-4 bg-white p-4 rounded-xl shadow-lg border">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-success/10 rounded-lg flex items-center justify-center">
                  <Icon name="TrendingUp" size={16} className="text-success" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground">
                    Aprovação
                  </p>
                  <p className="text-xs text-muted-foreground">Em 24 horas</p>
                </div>
              </div>
            </div>

            <div className="absolute -bottom-4 -right-4 bg-white p-4 rounded-xl shadow-lg border">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name="Heart" size={16} className="text-primary" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground">
                    Satisfação
                  </p>
                  <p className="text-xs text-muted-foreground">
                    98% dos clientes
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <Icon name="ChevronDown" size={24} className="text-muted-foreground" />
      </div>
    </section>
  );
};

export default HeroSection;
